// extracted by mini-css-extract-plugin
export default {"root":"OffRamp_root__pnXds"};